// generate the UniqueID for each workflow container
export default {
  methods: {
    createUID (prefix) {
      const rand = ((Math.random() * Math.pow(36, 4) << 0).toString(36))
      if (prefix !== '') {
        prefix += '__'
        return prefix + rand
      }
      return rand
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/uid.js